import React from 'react';

import Header from '@/core/components/Header';
import useGeoInput from '@/core/hooks/inputs/useGeoInput';
import { useIsLg } from '@/core/hooks/useMediaQuery';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const LocationInputHeader: React.FC<Pick<ReturnType<typeof useGeoInput>, 'isOpen' | 'onClose'> & { title?: string; placeholder?: string }> = ({ isOpen, title, placeholder, onClose }) => {
  const isLg = useIsLg();
  const { t } = useTranslationContext(['common']);

  return isOpen && !isLg && <Header content={title ?? placeholder ?? ''} onAfter={onClose ?? undefined} labelAfter={t('inputs.category.modal.close', { ns: 'common' })} />;
};
